import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "collapsible-wrap" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import { marked } from 'marked'
import CCustomerService from '@/components/CCustomerService.vue'
import { Getters } from '@/store/getters'


export default /*@__PURE__*/_defineComponent({
  __name: 'MInfoAndHelp',
  setup(__props) {

const store = useStore()
const { t } = useI18n()

const text = computed(() => {
  if (store.state.zone.gametype)
    return marked(
      t('infoAndHelp.main.collapsible_md', {
        gameName: t('generic.game.name_' + store.state.zone.gametype),
      })
    )
  else return ''
})
const textZone = computed(() => {
  if (zoneId.value && store.state.zone.gametype) {
    const text: string = t('infoAndHelp.main.' + zoneId.value, {
      gameName: t('generic.game.name_' + store.state.zone.gametype),
    }) as string
    return text && !/infoAndHelp\.main/.test(text) ? marked(text) : ''
  }
  return ''
})

const zoneId = computed(() => {
  return (store.getters as Getters).tournamentUi.zoneId
})

function toggleListener() {
  // console.log('Nothing tracked')
}

function onCustomer() {
  events.$emit('cs-form')
}

function clickHandler(e: Event) {
  const event: any = e
  if (event.target && event.target.tagName === 'A' && event.target.href) {
    if (/#gamerules/.test(event.target.href)) {
      events.$emit('game-rules', { gametype: store.state.zone.gametype })
    } else if (/#customerservice/.test(event.target.href)) {
      // ? this do not exists anymore
      const win: any = window.open('/gd/support/contact.xhtml', 'customer')
      win.focus()
    }
  }
  e.preventDefault()
}
/**
 * load game rules JS - there was no way to include them in the index.html after
 * the phonitaire-web - and the game rules needs the Vue instance from phonitaire-web
 */
function loadGameRules() {
  // make sure to load it only once
  if (!store.state.gameRulesLoaded) {
    store.commit('gameRulesLoaded', true)
    var script = document.createElement('script')
    script.src = '../game-rules-weblib/game-rules.umd.min.js'
    document.head.appendChild(script)
  }
}
loadGameRules()

return (_ctx: any,_cache: any) => {
  const _component_t_collapsible_list = _resolveComponent("t-collapsible-list")!
  const _component_t_toggle_box = _resolveComponent("t-toggle-box")!
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_content = _resolveComponent("t-content")!

  return (_openBlock(), _createBlock(_component_t_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_t_container, { class: "info-and-help" }, {
        default: _withCtx(() => [
          _createVNode(_component_t_toggle_box, {
            onToggle: toggleListener,
            title: _ctx.$t('infoAndHelp.main.title'),
            "qe-id": `tournament-faq-${zoneId.value}`,
            open: true
          }, {
            bottom: _withCtx(() => [
              _createVNode(CCustomerService, {
                class: "customer-service",
                onCustomer: onCustomer,
                text: _ctx.$t('infoAndHelp.main.customerService')
              }, null, 8, ["text"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (textZone.value)
                  ? (_openBlock(), _createBlock(_component_t_collapsible_list, {
                      key: 0,
                      "html-text": textZone.value,
                      clickTag: "h2",
                      onAction: clickHandler
                    }, null, 8, ["html-text"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_t_collapsible_list, {
                  "html-text": text.value,
                  clickTag: "h2",
                  onAction: clickHandler
                }, null, 8, ["html-text"])
              ])
            ]),
            _: 1
          }, 8, ["title", "qe-id"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})